/* globals zfUploader */

import { getDefaultErrorStringForXhr } from 'zoomforth_tools/error_messaging.js';

(function() {
  
  window.zfUploader = {};
  
  zfUploader.uploadInProgressWarning = 'You are currently uploading a file. Leaving this page will cancel the upload.';
  
  zfUploader.alertFn = function(alertString){
    window.alert(alertString);
  };
  
  zfUploader.CSRF_TOKEN = window.CSRF_TOKEN;
  
  
  zfUploader._withCSRFHeader = function (xhr) {
    xhr.setRequestHeader('X-CSRF-Token', zfUploader.CSRF_TOKEN);
  };
  
  // keep track of current uploads on page globally on the entire page,
  // unconnected to specific uploaders
  zfUploader.currentUploads = 0;
  
  zfUploader._prevOnBeforeUnload = null;

  zfUploader._addUpload = function(){
    if(zfUploader.currentUploads === 0){
      zfUploader._prevOnBeforeUnload = window.onbeforeunload || null;
      window.onbeforeunload = function(){
        return zfUploader.uploadInProgressWarning;
      };
    }
    zfUploader.currentUploads ++;
  };
  
  zfUploader._finishUpload = function(){
    zfUploader.currentUploads --;
    if(zfUploader.currentUploads === 0){
      window.onbeforeunload = zfUploader._prevOnBeforeUnload;
    }
  };
  
  // keep track of upload progress to S3 using AssetPrecursor
  
  zfUploader.AssetPrecursor = Backbone.Model.extend({
    urlRoot: '/asset_precursors',
    
    initialize: function(attrs, opts) {
      var me = this;

      this.on('error', function(model, xhr) {
        zfUploader.alertFn(getDefaultErrorStringForXhr(xhr));
      });

      this.file = opts.file;

      if (opts.enableThumbnails && this.canMakeThumbnail()) {

        var thumbnailReady = this.thumbnailReady = $.Deferred();
        var reader = new window.FileReader();
        reader.onload = function(e) {
          thumbnailReady.resolve(e.target.result, me.file.name);
        };
        // Read in the image file as a data URL.
        reader.readAsDataURL(this.file);  
      }
    },

    canMakeThumbnail: function() {
      return !!(window.FileReader && this.file && this.file.type.match('image.*'));
    },

    // Size in bytes!
    getFileSize: function() {
      return this.file.size;
    },

    isValidSize: function() {
      // We allow uploads up to 5GB
      var oneGB = 1073741824;
      return this.getFileSize() < oneGB * 5;
    },

    getFileType: function() {
      return this.file.type;
    },
    
    getAssetIdentifierString: function(){
      var assetType = this.get('assetType');
      var assetId = this.get('assetId');
      if (assetType && assetId) {
        return '' + assetType + '-' + assetId;
      }
      return null;
    },
    
    // these functions should be called by the uploader that the precursor belongs to
    
    failedToDetermineType: function(e, uploadData){
      this.trigger('failed-to-determine-type');
      this.trigger('ended');
      zfUploader.alertFn('We could not successfully process this file. Please make sure it is an image, video, or pdf.');
    },
    
    uploadBegun: function(e, uploadData){
      zfUploader._addUpload();
      this.trigger('upload-begun');
    },
    
    updateProgress: function(e, uploadData){
      var progressPercent = parseInt(uploadData.loaded / uploadData.total * 100, 10);
      this.trigger('progress', progressPercent, { loaded:uploadData.loaded, total: uploadData.total });
    },
    
    beginPostUploadProcessing: function(e, uploadData){
      var me = this;
      zfUploader._finishUpload();
      this.trigger('processing-begun');
      this.save({
        status:'processing'
      },{
        beforeSend: zfUploader._withCSRFHeader,
        patch: true

      }).done(function(){
        if (me.get('error')){
          me.trigger('processing-failed');
        } else {
          me.trigger('processing-complete');
        }
        me.trigger('ended');

      }).fail(function() {
        me.trigger('processing-failed');
        me.trigger('ended');

      });
      
    },
    
    uploadFailed: function(e, uploadData){
      zfUploader._finishUpload();
      this.trigger('upload-failed');
      this.trigger('ended');
      zfUploader.alertFn("Unfortunately, your upload failed. Check your internet connection and try again.");
    },

    onThumbnailReady: function(cb) {
      if (!this.thumbnailReady) {
        throw "UploaderView was not instantiated with the 'enableThumbnails' option";
      }
      return this.thumbnailReady.done(cb);
    }
    
  });

  
  zfUploader.UploaderView = Backbone.View.extend({
    
    className: "uploader-view",

    tagName: 'form',

    initialize: function(options){
      this.multiple = typeof options.multiple !== 'undefined' ? !!options.multiple : true;
      this.dropZone = options.dropZone || null;
      this.initialPrecursorData = options.initialPrecursorData || {};
      this.enableThumbnails = !!options.enableThumbnails;
      this.accept = _.isArray(options.accept) ? options.accept.join(',') : options.accept;
    },
    
    addFromBlob: function(blob) {
      this.$uploader.fileupload('add', {files: [blob]});
    },
    
    _renderInitialForm: function() {
      // Render the intial form inputs
      const $form = this.$el;
      const $fileInp = $('<input class="action-upload-file" type="file" name="file" />');
      if (this.multiple) {
        $fileInp.attr('multiple', ''); // for some reason jquery makes this multiple=multiple
      }
      if (this.accept) {
        $fileInp.attr('accept', this.accept);
      }
      $form.append($fileInp);

      this.$uploader = $fileInp;

    },

    _renderFormFromPresignedParams: function({ fields, url }) {
      // FYI: This was re-written to support CMK

      const $form = this.$el;
      $form.find('.presigned-param').remove();
      $form.attr({
        action: url,
        method: 'POST',
        enctype: 'multipart/form-data'
      });

      _.each(fields, (value, key)=> {
        $form.append(`<input class="presigned-param" type="hidden" name="${key}" value="${value}" />`);
      });

    },

    _bindFileUploader : function(){
      var me = this;
      me.$uploader.fileupload({
        dataType: 'xml', 
        dropZone: this.dropZone,
        add: function(e, data){
          var precursor = new zfUploader.AssetPrecursor({
            name: data.files[0].name,
            mime: data.files[0].type,
            size: data.files[0].size
          }, {
            enableThumbnails: me.enableThumbnails,
            file: data.files[0] // Make local files available on precursor object
          });
          precursor.set(me.initialPrecursorData);
          data.precursor = precursor;
          me.trigger('started', precursor);
          
          precursor.save(
            undefined, 
            {
              beforeSend: zfUploader._withCSRFHeader
            }
          ).done(function(response){
            
            me._renderFormFromPresignedParams(response.s3Params);

            if (!precursor.isValidSize()) {
              this.trigger('ended');
              zfUploader.alertFn('We could not successfully process this file. Please make sure your file size is less than 5 gigabytes.');
              return;
            }

            if (!response.presumedType){
              // eventually we can have a modal ask to clarify the file type and then 
              // treat the file as if it is that type. Until then, just fail
              precursor.failedToDetermineType(e, data);
            } else {
              precursor.uploadBegun(e, data);
              data.submit();
            }
          });
        },
        progress: function(e, data){
          data.precursor.updateProgress(e, data);
        },
        done: function(e, data){
          data.precursor.beginPostUploadProcessing(e, data);
        },
        fail: function(e, data){
          data.precursor.uploadFailed(e, data);
        }
      });

    },

    fakeClick: function() {
      // Note this does not work in IE8 & 9! The user must actually click
      // on the fileinput element
      this.$('input[type=file]').click();
    }
    
  },{
    create: function($container, instanceOptions){
      var fileUploader = new zfUploader.UploaderView(instanceOptions || {});
      fileUploader._renderInitialForm();
      $container.append(fileUploader.$el);
      fileUploader._bindFileUploader();
      return fileUploader;
    }
  });
  
})();
